// plugins/fontawesome.js
import { library, config } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons' // Importiere alle Solid-Icons
import { fab } from '@fortawesome/free-brands-svg-icons' // Importiere alle Brand-Icons
import { far } from '@fortawesome/free-regular-svg-icons' // Importiere alle Regular-Icons

// Optional: Nur bestimmte Icons importieren, um die Bundle-Größe zu reduzieren
// import { faUser, faCog } from '@fortawesome/free-solid-svg-icons'

// Füge die importierten Icons zur Bibliothek hinzu
library.add(fas) // Fügt alle Solid-Icons hinzu
library.add(fab) // Fügt alle Brand-Icons hinzu
library.add(far) // Fügt alle Regular-Icons hinzu
// library.add(faUser, faCog) // Fügt nur bestimmte Icons hinzu

// Optional: Deaktiviere die automatische CSS-Injektion, wenn du es über Nuxt/Vite selbst verwaltest
config.autoAddCss = false

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('font-awesome-icon', FontAwesomeIcon)
})